<template>
  <div>
    <b-badge
      v-for="(item, index) in itemsToDisplay"
      :key="index"
      v-b-tooltip.hover.top="getTooltip(item)"
      :variant="getVariant(item)"
      :class="`mr-1 ${badgeClass}`"
      @click="$emit('click', item)"
    >
      <span v-if="rawText">{{ item }}</span>
      <span v-else-if="node">{{ item.node[itemKey] }}</span>
      <span v-else-if="flatArray">{{ item }}</span>
      <span v-else-if="resolveDeepProperty(itemKey, item)">
        {{ resolveDeepProperty(itemKey, item) }}
      </span>
    </b-badge>
    <b-badge
      v-if="additionalItems.length > 0"
      v-b-tooltip.hover.top="getAdditionalItems"
      :variant="variant"
    >
      <span>...</span>
    </b-badge>
  </div>
</template>

<script>
export default {
  name: 'BadgeCollection',
  props: {
    badgeClass: {
      type: String,
      default: '',
    },
    flatArray: {
      type: Boolean,
      default() {
        return false;
      },
    },
    items: {
      type: Array,
      required: true,
    },
    itemKey: {
      type: String,
      default() {
        return 'name';
      },
    },
    itemVariant: {
      type: Boolean,
      default() {
        return false;
      },
    },
    maxVisible: {
      type: Number,
      default() {
        return null;
      },
    },
    node: {
      type: Boolean,
      default() {
        return false;
      },
    },
    rawText: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: [String, Function],
      default: null,
    },
    variant: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      additionalItems: [],
      itemsToDisplay: [],
    };
  },
  watch: {
    items: {
      immediate: true,
      handler(value) {
        if ('undefined' === typeof value) {
          this.itemsToDisplay = [];
          this.additionalItems = [];
          return;
        }

        if (null !== this.maxVisible) {
          this.itemsToDisplay = value.slice(0, this.maxVisible);
          this.additionalItems = value.slice(this.maxVisible, value.length);
          return;
        }

        this.itemsToDisplay = value ?? [];
      },
    },
  },
  methods: {
    getAdditionalItems() {
      const additional = [];
      this.additionalItems.forEach((item) => {
        if (this.rawText) {
          additional.push(item);
        } else if (this.node) {
          additional.push(item.node[this.itemKey]);
        } else {
          additional.push(this.resolveDeepProperty(this.itemKey, item));
        }
      });

      return additional.join(', ');
    },
    getTooltip(item) {
      if (null === this.tooltip) {
        return null;
      }

      if ('function' === typeof this.tooltip) {
        return this.tooltip(item);
      }

      const property = this.resolveDeepProperty(this.tooltip, item);

      if (!property) {
        return null;
      }

      if ('undefined' === property) {
        return null;
      }

      return property;
    },
    getVariant(item) {
      if (this.itemVariant) {
        return item.variant ?? null;
      }

      return this.variant;
    },
  },
};
</script>

<style scoped>

</style>
